(function(Drupal, $) {

  Drupal.behaviors.fullWidthPage = {
    attach(context) {
      if (window.location.pathname.split('/')[1] === 'search') {
        const params = new URLSearchParams(window.location.search);
        const q = params.get('q');
        $('#nav-search').val(q);
        $('#search-state')
          .prop('checked', true)
          .prop("disabled", true);
      };
    },
  };

})(Drupal, jQuery);
